export const updateAssetForCurrentProcessingContext = ({
    data,
    currentUploadId,
    currentAssetGroupId,
    assetsDispatch,
}) => {
    const currentContext = data.attrs.upload_id === currentUploadId ||
        data.attrs.storage_folder_id === currentAssetGroupId

    if (!currentContext) return false

    assetsDispatch({type: 'updateAsset', asset: {id: data.asset_id, ...data.attrs}})
    return true
}
